import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridVendorSharedComponent } from '@unity/shared/grid-vendor-shared/grid-vendor-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-vendor-page',
  standalone: true,
  imports: [PageContainerComponent, GridVendorSharedComponent, ActionSharedComponent],
  templateUrl: './list-vendor-page.component.html',
  styleUrl: './list-vendor-page.component.scss',
})
export class ListVendorPageComponent {
  protected createVendorAction = QuickActions.CreateVendor;
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
